import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "10px",
	height: "16px",
	viewBox: "0 0 10 16",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Shape" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Wireframes-Mobile-Agent-Yulia",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Home---Messages---Profil",
				transform: "translate(-336.000000, -650.000000)",
				fill: "#7A7A7A",
				children: /* @__PURE__ */ _jsx("polygon", {
					id: "Shape",
					points: "336 651.866667 337.891892 650 346 658 337.891892 666 336 664.133333 342.216216 658"
				})
			})
		})
	]
});
export default SvgArrow;
